/**
 *  Campaigns actions module file
**/

import campaignsService from '@/api/campaignsService'
import { ACTIONS, MUTATIONS } from './constants'

export const actions = {
  async [ACTIONS.FETCH_COPY_TASKS] ({ commit, state }, { reset = true, page_size: rpp = 20, ...params } = {}) {
    commit(MUTATIONS.SET_COPY_TASKS_LOADING, true)
    try {
      const data = await campaignsService.getCampaignsTasks({ ...params, page_size: rpp })
      const results = reset ? data.results : state.copy_tasks.results.concat(data.results)
      commit(MUTATIONS.SET_COPY_TASKS, { ...data, results })
    } catch (err) {
      // eslint-disable-next-line
      console.error('[ACTIONS.FETCH_COPY_TASKS] Error fetching tasks', err)
    }
    commit(MUTATIONS.SET_COPY_TASKS_LOADING, false)
  },
  async [ACTIONS.DELETE_COPY_TASKS] ({ commit }) {
    commit(MUTATIONS.SET_COPY_TASKS_LOADING, true)
    try {
      await campaignsService.deleteCampaignTasks()
    } catch (err) {
      // eslint-disable-next-line
      console.error('[ACTIONS.DELETE_COPY_TASKS] Error deleting tasks', err)
    }
    commit(MUTATIONS.SET_COPY_TASKS_LOADING, false)
  }
}
